import { render } from "./TireSizeWheel.vue?vue&type=template&id=4ba0e8de"
import script from "./TireSizeWheel.vue?vue&type=script&lang=js"
export * from "./TireSizeWheel.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TireSizeWheel.vue?vue&type=style&index=0&id=4ba0e8de&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__